var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibonFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3722 11.9476L6.29639 10.6236C5.6916 10.4269 5.6916 9.57125 6.29639 9.37448L10.3722 8.05054C10.6448 7.96239 10.7944 7.66947 10.7054 7.39702L10.3883 6.4212C10.3001 6.14875 10.0071 5.99917 9.7345 6.08821L5.65864 7.41215C5.05385 7.60892 4.55061 6.91623 4.92381 6.40161L7.44272 2.93548C7.61107 2.70399 7.55941 2.37901 7.32782 2.21074L6.4968 1.60708C6.26521 1.4388 5.94011 1.49044 5.77176 1.72193L3.25285 5.18806C2.87876 5.70268 2.06465 5.43825 2.06465 4.80254V0.519073C2.06465 0.232381 1.83218 0 1.54537 0H0.51928C0.232474 0 0 0.232381 0 0.519073V19.4808C0 19.7675 0.232474 19.9999 0.51928 19.9999H1.54626C1.83307 19.9999 2.06554 19.7675 2.06554 19.4808V15.1974C2.06554 14.5617 2.87965 14.2972 3.25374 14.8118L5.77265 18.278C5.941 18.5095 6.26521 18.5611 6.49769 18.3928L7.32871 17.7892C7.5603 17.6209 7.61196 17.2959 7.44361 17.0644L4.9247 13.5983C4.55061 13.0837 5.05385 12.391 5.65953 12.5878L9.7354 13.9117C10.008 13.9998 10.301 13.8512 10.3892 13.5787L10.7063 12.602C10.7944 12.3296 10.6457 12.0366 10.3731 11.9485L10.3722 11.9476Z",
    fill: "#1D8158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibonFull);
export default __webpack_public_path__ + "static/media/ribon-full.f3389ac5240f12c4b689ab99cd2e1944.svg";
export { ForwardRef as ReactComponent };